import { Capacitor } from '@capacitor/core'

/**
 * API Base URL Configuration
 *
 * For production builds:
 * - Set VITE_API_URL in your .env.production file to your production API URL
 *
 * For development:
 * - Native apps: Uses VITE_DEV_API_URL or falls back to localhost
 * - Web: Uses Vite proxy (empty string)
 *
 * Example .env.production:
 *   VITE_API_URL=https://api.brightseed.app
 *
 * Example .env.development:
 *   VITE_DEV_API_URL=http://192.168.0.252:3001
 */

export function getApiBaseUrl(): string {
  // Production: use the configured API URL
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }

  // Development
  if (Capacitor.isNativePlatform()) {
    // Native apps need the full URL since they can't use Vite proxy
    // Use VITE_DEV_API_URL or provide a default for local development
    return import.meta.env.VITE_DEV_API_URL || 'http://localhost:3001'
  }

  // Web dev: use empty string for Vite proxy
  return ''
}

export const API_BASE_URL = getApiBaseUrl()
